// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2YC3gg0NfaYQzMMKJNv0kh","icon":"Tyo43d8xoDxiDLYWqVhLl","active":"_1XNNVd2wSUObJdXZwsVCrG"};